export default [
  {
    srno: "1",
    // img: require("../img/extra1.jpg"),
    orderno: "08236786818"
  },
  {
    srno: "2",
    // img: require("../img/extra2.jpg"),
    orderno: "08236786818"
  }
];
